import ReactGA from 'react-ga';
import requext from '../../utils/requext';
import { takeLatest, put, call } from 'redux-saga/effects';
import {
    LOGIN_REQUEST,
    LOGIN_SUCCESS,
    LOGIN_FAILED,
    DELETE_USER_REQUEST,
    UPDATE_USER_REQUEST,
    UPDATE_USER_SUCCESS,
    CREATE_USER_REQUEST,
    CREATE_USER_SUCCESS,
    CREATE_USER_FAILURE,
    UPDATE_USER_FAILURE,
    GET_ALL_USERS_REQUEST,
    GET_ALL_USERS_SUCCESS,
    FETCH_MEMBERSHIP_REQUEST,
    FETCH_MEMBERSHIP_SUCCESS,
    UPDATE_MEMBERSHIP_REQUEST,
    LOGIN_WITH_REQUEST,
} from '../actionTypes';
import graphFetch from '../../util/graphFetch';
import * as actions from '../actions';

function* requestLogin({ query }) {
    try {
        const response = yield requext(undefined, JSON.stringify(query));
        const { data } = yield response.json();
        if (data.login.success) {
            yield put({ type: LOGIN_SUCCESS, payload: data.login });
        } else {
            yield put({ type: LOGIN_FAILED, payload: data.login });
        }
    } catch (err) {
        console.error(err);
    }
}

function* loginWithRequest({ payload }) {
    try {
        const mutation = true;
        const query = {
            queryName: 'loginWith',
            args: payload,
            select: `token
            success 
            message
            expiresAt
            user {
                id 
                roles
                name
                email 
                avatar
                country
                membership { promo }
            }`,
        };
        const resp = yield call(graphFetch, query, mutation);

        if (resp?.data?.loginWith.success) {
            const data = {
                ...resp?.data.loginWith,
                provider: payload.provider,
            };
            yield put({ type: LOGIN_SUCCESS, payload: data });
        } else {
            yield put({ type: LOGIN_FAILED, payload: resp?.data.loginWith });
        }
    } catch (err) {
        console.error(err);
    }
}

function* updateUser({ payload }) {
    const selectable = ['name', 'email', 'avatar'];
    const [id, updateUserInput] = payload;
    const selects = Object.keys(updateUserInput)
        .filter((key) => selectable.includes(key))
        .join(' ');

    try {
        const query = {
            query: `mutation updateUser($id: ID!, $updateUserInput: UpdateUserInput) {
                updateUser(id: $id, updateUserInput: $updateUserInput) {
                    success 
                    message 
                    user {
                        id
                        ${selects}
                    }
                }
            }`,
            variables: { id, updateUserInput },
        };
        const resp = yield requext(undefined, JSON.stringify(query));
        const { data } = yield resp.json();
        if (data && data.updateUser && data.updateUser.success) {
            yield put({ type: UPDATE_USER_SUCCESS, payload: data.updateUser });
        } else {
            const payload = {
                message:
                    data && data.updateUser
                        ? data.updateUser.message
                        : 'Could not update user',
            };
            yield put({ type: UPDATE_USER_FAILURE, payload });
        }
    } catch (err) {}
}

function* createUser({ payload }) {
    try {
        const { email, password, passthrough, promo } = payload;
        const options = {
            queryName: 'createUser',
            args: {
                passthrough,
                email: { value: email, type: 'String!' },
                promo: { value: promo, type: 'String!' },
                password: { value: password, type: 'String!' },
            },
            select: `
                success
                token 
                message
                expiresAt
                user {
                    id 
                    name
                    email
                    avatar
                    country
                }
            `,
        };
        const { data } = yield call(graphFetch, options, true);
        if (data?.createUser?.success) {
            yield put({ type: CREATE_USER_SUCCESS, payload: data.createUser });
            yield call(sendToIntegromat, email);
            ReactGA.event({
                category: 'User',
                action: 'SignUp Success',
            });
        } else {
            let payload = data
                ? data.createUser
                : { message: 'Something went wrong!' };

            yield put({ payload, type: CREATE_USER_FAILURE });
            ReactGA.event({
                category: 'User',
                action: 'SignUp Failed',
            });
        }
    } catch (err) {}
}

function* getAllUsers({ payload }) {
    try {
        const options = {
            queryName: 'getUsers',
            select: `
                id email createdAt isBanned
                sites {
                    id url
                }
                membership {
                    planId
                }
            `,
        };
        const { data } = yield call(graphFetch, options);
        if (data && data.getUsers) {
            yield put({ type: GET_ALL_USERS_SUCCESS, payload: data.getUsers });
        }
    } catch (err) {
        console.log(err);
    }
}

function* fetchMembership() {
    try {
        const options = {
            queryName: 'profile',
            select: `id membership { status promo planId renewAt cancelUrl updateUrl cancellationEffectiveDate subscriptionId }`,
        };
        const { data } = yield call(graphFetch, options);
        if (data.profile) {
            yield put({
                type: FETCH_MEMBERSHIP_SUCCESS,
                payload: data.profile,
            });
        }
    } catch (err) {
        throw new Error(`Error in Google Siteverify API. ${err.message}`);
    }
}

function* updateMembership({ payload }) {
    try {
        const mutation = true;
        const { planId, subscriptionId } = payload;
        const options = {
            queryName: 'updateMembership',
            args: {
                planId,
                subscriptionId,
            },
        };
        const { data } = yield call(graphFetch, options, mutation);
        if (data.updateMembership) {
            yield put(actions.refreshToken());
            yield put(actions.fetchMembership());
            yield put(
                actions.updateMembershipSuccess({
                    message: 'Successfully updated the membership',
                })
            );
        } else {
            yield put(
                actions.updateMembershipFailure({
                    message: 'Something went wrong, contact support!',
                })
            );
        }
    } catch (err) {
        console.log('ANWARN', err);
    }
}

function* sendToIntegromat(email) {
    try {
        const apiUrl =
            'https://hook.integromat.com/cgpdu27oz0rxt5d8xlqbf8uhfhy5nnby';
        const resp = yield fetch(apiUrl, {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ e_mail: email }),
        });
        return resp.ok;
    } catch (err) {
        throw new Error(`sendToIntegromat fails`);
    }
}

function* deleteUser({ id }) {
    try {
        const options = {
            queryName: 'deleteUser',
            args: {
                id: { type: 'ID', value: id },
            },
        };
        const result = yield call(graphFetch, options, true);
        if (result?.data?.deleteUser) {
            yield put(
                actions.deleteUserSuccess({
                    id,
                    message: 'User deleted successfully!',
                })
            );
        } else {
            yield put(
                actions.deleteUserFailure({
                    id,
                    message: 'User deletion failed!',
                })
            );
        }
    } catch (err) {
        yield put(
            actions.deleteSiteFailure({ id, message: 'User deletion failed!' })
        );
    }
}

export default [
    takeLatest(LOGIN_REQUEST, requestLogin),
    takeLatest(DELETE_USER_REQUEST, deleteUser),
    takeLatest(CREATE_USER_REQUEST, createUser),
    takeLatest(UPDATE_USER_REQUEST, updateUser),
    takeLatest(GET_ALL_USERS_REQUEST, getAllUsers),
    takeLatest(LOGIN_WITH_REQUEST, loginWithRequest),
    takeLatest(FETCH_MEMBERSHIP_REQUEST, fetchMembership),
    takeLatest(UPDATE_MEMBERSHIP_REQUEST, updateMembership),
];
